import type checkoutEn from "./checkout.en";

const checkoutAr: Record<keyof typeof checkoutEn, string> = {
  "settings.checkout": "إتمام الطلب",
  "settings.checkout_hint": "طريقة التواصل وحقول النموذج والإكرامية وشكل صفحة الدفع",
  "co.title": "إتمام الطلب",
  "co.preview": "معاينة",
  "co.style": "الشكل",
  "co.style_hint": "شعارك وألوانك في صفحة الدفع وصفحة حالة الطلب.",
  "co.logo": "الشعار",
  "co.logo_add": "إضافة شعار",
  "co.accent": "الأزرار والتمييز",
  "co.radius": "استدارة الزوايا: {n} بكسل",
  "co.sample": "معاينة:",
  "co.pay_now": "ادفع الآن",
  "co.contact": "طريقة التواصل مع العميل",
  "co.contact_hint": "ما يستخدمه العملاء لإتمام الطلب وتلقي تحديثاته.",
  "co.contact_method": "يكمل العملاء الدفع باستخدام",
  "co.contact.either": "رقم الهاتف أو البريد الإلكتروني",
  "co.contact.either_hint": "يختار العميل: تصل التحديثات برسالة نصية أو بالبريد.",
  "co.contact.email": "البريد الإلكتروني",
  "co.contact.phone": "رقم الهاتف",
  "co.contact.phone_hint": "شائع في الخليج: تصل التحديثات برسائل نصية.",
  "co.require_login": "يجب على العملاء تسجيل الدخول قبل الدفع",
  "co.require_login_hint": "لا يمكن للعملاء الدفع إلا بحساب.",
  "co.info": "معلومات العميل",
  "co.full_name": "الاسم الكامل",
  "co.name.last": "اسم العائلة فقط مطلوب",
  "co.name.both": "الاسم الأول واسم العائلة مطلوبان",
  "co.company": "اسم الشركة",
  "co.address2": "سطر العنوان 2 (الشقة، الوحدة، إلخ)",
  "co.shipping_phone": "رقم هاتف عنوان الشحن",
  "co.vis.hidden": "عدم الإظهار",
  "co.regional": "حقول العنوان حسب الدولة",
  "co.regional_hint": "اطلب تفاصيل العنوان التي يحتاجها مندوبو التوصيل في كل دولة، مثل أرقام المنطقة والشارع والمبنى في قطر. يحتفظ كل عنوان بالحقول المعتادة أيضاً، فيعمل الدفع والتوصيل في كل مكان.",
  "co.regional_other": "كل الدول الأخرى",
  "co.regional_on": "{n} مفعّلة",
  "co.regional_off": "العنوان المعتاد فقط",
  "co.regional_address1": "اجعل سطر العنوان اختيارياً",
  "co.regional_address1_hint": "عندما تكفي هذه الحقول لتحديد مكان التوصيل. على العميل أن يملأ سطر العنوان أو أحد هذه الحقول.",
  "co.vis.optional": "اختياري",
  "co.vis.required": "مطلوب",
  "co.marketing": "خيارات التسويق",
  "co.marketing_hint": "دع العملاء يشتركون في التسويق عند الدفع. اترك المربع غير محدد حيث يتطلب القانون الموافقة.",
  "co.mkt.email": "التسويق عبر البريد",
  "co.mkt.sms": "التسويق عبر الرسائل النصية",
  "co.mkt.hidden": "عدم الإظهار",
  "co.mkt.unchecked": "إظهار، غير محدد",
  "co.mkt.checked": "إظهار، محدد مسبقاً",
  "co.tipping": "الإكرامية",
  "co.tipping_enable": "إظهار خيارات الإكرامية عند الدفع",
  "co.tipping_hint": "يمكن للعملاء إضافة إكرامية كنسبة من طلبهم.",
  "co.tip_n": "الخيار {n}",
  "co.processing": "معالجة الطلبات",
  "co.billing_same": "استخدام عنوان الشحن كعنوان للفواتير افتراضياً",
  "co.notes": "إضافة حقل ملاحظة",
  "co.notes_hint": "يمكن للعملاء ترك ملاحظة مع طلبهم.",
  "co.terms": "يجب على العملاء الموافقة على شروط الخدمة",
  "co.terms_hint": "مربع اختيار قبل «ادفع الآن».",
  "ab.title": "السلال المستردة",
  "ab.empty_title": "لا توجد سلال لاستردادها",
  "ab.empty_body": "تظهر هنا عمليات الدفع عندما يُدخل العميل بيانات التواصل ويغادر دون أن يدفع.",
  "ab.search": "ابحث بالبريد أو الهاتف أو الاسم",
  "ab.none": "لا توجد نتائج مطابقة.",
  "ab.col.checkout": "عملية الدفع",
  "ab.col.date": "التاريخ",
  "ab.col.placed_by": "بواسطة",
  "ab.col.status": "حالة الاسترداد",
  "ab.col.total": "الإجمالي",
  "ab.recovered": "تم الاسترداد",
  "ab.not_recovered": "لم يُسترد",
  "ab.abandoned_on": "تُرك في {when}",
  "ab.details": "تفاصيل عملية الدفع",
  "ab.subtotal": "المجموع الفرعي",
  "ab.discount": "الخصم",
  "ab.shipping": "الشحن",
  "ab.tax": "الضرائب",
  "ab.tax_included": "الضرائب (مشمولة)",
  "ab.total": "الإجمالي",
  "ab.recover": "استرداد عملية الدفع",
  "ab.recover_hint": "أرسل هذا الرابط للعميل: يفتح عملية الدفع بكل ما أدخله. رسائل الاسترداد تأتي مع أدوات التسويق.",
  "ab.copy": "نسخ الرابط",
  "ab.copied": "تم نسخ الرابط",
  "ab.customer": "العميل",
  "ab.view_customer": "عرض العميل",
  "ab.subscribed": "مشترك في التسويق عبر البريد",
  "ab.not_subscribed": "غير مشترك في التسويق عبر البريد",
  "ab.shipping_address": "عنوان الشحن",
  "ab.activity": "النشاط",
  "ab.started": "بدأ في {when}",
  "ab.last_seen": "آخر نشاط {when}",
};

export default checkoutAr;
